import { ConfigOption } from '@ngx-formly/core';
import { FormlyAddressPanelWrapperComponent } from './formly-address-panel-wrapper/formly-address-panel-wrapper.component';
import { FormlyAddressPostalLinksListComponent } from './formly-address-postal-links-list/formly-address-postal-links-list.component';
import { WidgetPostalAddressesComponent } from './widget-postal-addresses/widget-postal-addresses.component';

export const POSTAL_ADDRESS_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-crm-postal-address-list', component: WidgetPostalAddressesComponent },
  { name: 'formly-address-postal-links-list', component: FormlyAddressPostalLinksListComponent },
]

export const POSTAL_ADDRESS_FORMLY_WRAPPERS: ConfigOption['wrappers'] = [
  { name: 'address-panel', component: FormlyAddressPanelWrapperComponent }, // Since is not in use for any formly field.
]
